module.exports = __webpack_public_path__ + "static/media/lockIcon.8528753a.svg";